export default __webpack_public_path__ + "static/media/farmacia.ea4989fe.jpeg";